<template>
  <div class="organizationUser" v-loading="loading" element-loading-text="数据加载中">
    <el-row class="userManager-title" v-if="isViewTitle">
      <breadCrubm :navMenu="['用户管理']">
      </breadCrubm>
    </el-row>
    <!-- 左边操作区域 -->
    <div class="leftMenu" :style="{ height: isViewTitle ? '' : '100%' }" v-loading="searchLoading">
      <!-- 切换操作 -->
      <div class="tapButtons">
        <span :class="['tap-button tap-button-left', orgShow ? 'active' : '']" @click="orgShow = true">组织</span>
        <span :class="['tap-button tap-button-right', orgShow ? '' : 'active']" @click="orgShow = false">角色</span>
      </div>
      <div class="search-wrap">
        <!-- 选择框 -->
        <el-select class="selectArea" v-model="search" :style="{ '--el-border-radius-base': '50px' }" placeholder="请选择">
          <el-option label="按姓名搜索" value="names" />
          <el-option label="按登录名搜索" value="username" />
          <el-option label="按手机号搜索" value="phone" />
        </el-select>
        <div class="search-box">
          <search @search="searchCallBack" v-model:value="searchWd" />
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="menuList">
        <template v-if="!isSearch">
          <div class="orgBox" v-show="orgShow">
            <el-scrollbar style="height: 100%; width: 100%" class="el-menu-scrollbar__wrap">
              <el-tree ref="orgTree" :props="props" :load="loadNode" :highlight-current="true" accordion
                :default-expanded-keys="defaultShowNodes" :node-key="isSpace ? 'organizationId' : 'roleId'"
                :key="treekey" lazy @node-click="thisTreeUserCh">
                <template v-slot="{ data, node }">
                  <div style="position: relative;width: 100%;">
                    <span class="line" v-show="node.level !== 1"></span>
                    <el-tooltip class="item" effect="dark" :content="data.name" placement="top">
                      <span class="org-name">{{ dealShowName(data) }}</span>
                    </el-tooltip>
                    <span class="none-type" v-if="dealType(data.type)"
                      :style="{ color: labelView({ val: data.type, type: 'color' }), backgroundColor: labelView({ val: data.type, type: 'background' }) }">
                      {{ dealType(data.type) }}
                    </span>
                    <span class="none-type" v-else>无类型</span>
                    <!-- 更多设置 -->
                    <el-popover placement="bottom" popper-class="more-operate" width="100" trigger="hover">
                      <p @click="dealOrg(data, node, 0)">新增下级组织</p>
                      <p @click="dealOrg(data, node, 1)">编辑组织信息</p>
                      <p @click="dealOrg(data, node, 2)">删除组织</p>
                      <template v-if="data.type !== 8 && data.type !== ''">
                        <p v-if="data.type < 4 || data.type === 9" @click="onClickOrganization(1, 1, data)">批量创建</p>
                        <p v-if="data.type !== -1" @click="onClickOrganization(3, 2, data)">批量导入管理员</p>
                        <p v-if="data.type > 3 && data.type < 7" @click="onClickOrganization(1, '', data)">快速创建</p>
                        <p v-if="data.type === 4 || data.type === 5" @click="onClickOrganization(3, 4, data)">创建行政部门</p>
                        <template v-if="data.type === 7">
                          <p @click="onClickOrganization(1, '', data)">创建行政班</p>
                          <p @click="onClickOrganization(3, 3, data)">创建自定义班级</p>
                        </template>
                      </template>
                      <template #reference>
                        <i class="iconfont icon-xiangqing" />
                      </template>
                    </el-popover>
                  </div>
                </template>
              </el-tree>
            </el-scrollbar>
          </div>
          <div class="roleBox" v-show="!orgShow">
            <el-scrollbar style="height: 100%; width: 100%" class="el-menu-scrollbar__wrap">
              <el-tree ref="userTree" :props="props" :load="loadNodeRole" :highlight-current="true" accordion
                node-key="roleId" lazy @node-click="thisTreeUserCh">
                <template v-slot="{ data }">
                  <div>
                    <p>{{ data.name }}</p>
                  </div>
                </template>
              </el-tree>
            </el-scrollbar>
          </div>
        </template>
        <!-- 搜索的结果 -->
        <template v-else>
          <el-scrollbar style="height: 100%; width: 100%" class="el-menu-scrollbar__wrap">
            <ul class="search-result" v-if="!orgShow || !isSpace">
              <li class="search-result-title">{{ orgShow ? '组织' : '角色' }}</li>
              <li v-for="(item, index) in groupSerchData" class="search-result-item"
                @click="resultClick(orgShow ? 0 : 1, item)" :key="index">
                {{ item.name }}
              </li>
            </ul>
            <ul class="search-result">
              <li class="search-result-title">用户</li>
              <li v-for="(item, index) in userSerchData" @click="handleEdit(index, item)" class="search-result-item"
                :key="index">
                {{ item.realname }}
              </li>
            </ul>
          </el-scrollbar>
        </template>
      </div>
    </div>
    <!--部门-->
    <div class="rightAppManager" v-show="orgShow" :style="{ height: isViewTitle ? '' : '100%' }">
      <div class="AppManager-title">
        <div class="goBack" @click="$router.replace('/adminMain')" v-if="$route.path.indexOf('admins') !== -1">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="tapChangeArea">
          <el-button-group>
            <el-button :type="departmentShow ? 'primary' : 'test'" size="mini"
              @click="departmentShow = true">组织成员</el-button>
            <el-button :type="departmentShow ? 'test' : 'primary'" size="mini"
              @click="departmentShow = false">子组织</el-button>
          </el-button-group>
        </div>
        <div class="buttonArea">
          <!-- <el-button @click="popupDeptEditEvent(0)">编辑当前组织</el-button> -->
          <!-- 子部门不显示 -->
          <template v-if="departmentShow">
            <el-button type="primary" @click="topBtnHandle(0)">
              {{ departmentShow ? "新建用户" : "添加子组织" }}
            </el-button>
            <el-button @click="topBtnHandle(1)">导入/导出</el-button>
            <el-button @click="topBtnHandle(2)">excel复制</el-button>
            <el-button v-if="!isSpace" @click="topBtnHandle(3)">批量删除用户</el-button>
            <el-button @click="topBtnHandle(4)">设置为组织管理员</el-button>
            <el-dropdown style="position:relative;" trigger="click" placement="bottom" @command="topBtnHandle">
              <el-button>更多操作<i class="el-icon-caret-bottom"></i></el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :command="5">邀请加入</el-dropdown-item>
                  <el-dropdown-item :command="6">移出本组织</el-dropdown-item>
                  <el-dropdown-item :command="7">调入其他组织</el-dropdown-item>
                  <el-dropdown-item :command="8">调入本组织</el-dropdown-item>
                  <el-dropdown-item :command="9">未登录查询</el-dropdown-item>
                </el-dropdown-menu>
              </template>
              <el-date-picker
                style="position:absolute;left:20px;bottom:0;z-index:-1;width:1px;height:1px;overflow:hidden;opacity:0;"
                ref="datepicke" v-model="nologinCheck" type="daterange" align="right" unlink-panels
                value-format="timestamp" :picker-options="pickerOptions" @change="changeTime">
              </el-date-picker>
            </el-dropdown>
            <el-button v-if="showRestBtn" @click="topBtnHandle(10)">重置选中用户密码</el-button>
            <el-button v-if="showRestBtn" @click="topBtnHandle(11)">重置所有用户密码</el-button>
            <span class="buttonRightArea">
              子组织成员
              <el-switch v-model="userChooseOrg" @change="userChooseEvent(0)">
              </el-switch>
            </span>
          </template>
        </div>
      </div>
      <!-- padding-bottom原来的值是60px -->
      <div class="AppManager-list" style="height: calc(100% - 145px);padding-bottom: 73px;" v-show="departmentShow"
        v-loading="loadingUser">
        <el-table :data="departmentDatas.data" height="100%" border :stripe="true"
          :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }"
          :header-cell-class-name="'headerTopClass'" @selection-change="departmentChange"
          :row-class-name="tableRowClassName" cell-class-name="cell_style" style="width: 100%">
          <el-table-column type="selection" width="40" />
          <template v-for="list in userConfig" :key="list.props">
            <el-table-column v-if="list.props === 'type'" show-overflow-tooltip :key="list.props" :label="list.label"
              :min-width="list.width">
              <template v-slot="scope">
                {{ (scope.row[list.props] || scope.row[list.props] === 0) && list.options[scope.row[list.props]] ?
                  list.options[scope.row[list.props]] : ''}}
              </template>
            </el-table-column>
            <el-table-column v-else-if="list.props === 'orders'" :label="list.label" :min-width="list.width">
              <template v-slot="scope">
                <div @dblclick="upSort(scope.row)" style="cursor: pointer;">
                  <el-input v-if="upOrganizationId && upOrganizationId === scope.row.userId" type="number"
                    v-model="orgId" size="mini" class="sort-input" :ref="'id' + scope.row.userId" @click.stop
                    @blur="upSortFun(scope.row)" @input="upOrgId" />
                  <template v-else>{{ scope.row[list.props] || 0 }}</template>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else show-overflow-tooltip :label="list.label" :min-width="list.width">
              <template v-slot="scope">
                <template v-if="list.options && (scope.row[list.props] || scope.row[list.props] === 0)">{{ list.options[scope.row[list.props] + list.optionsIndex][list.optionsProps]}}</template>
                <template v-else>{{ scope.row[list.props] }}</template>
              </template>
            </el-table-column>
          </template>
          <el-table-column fixed="right" align="center" label="操作" min-width="100px">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.openid ? '点击解绑微信' : '当前未绑定微信'"
                placement="bottom-end">
                <i class="icon iconfont icon-weixin" @click="uniteWx(scope.row)"
                  :style="{ color: !scope.row.openid ? '#999999' : '#09BB07' }" />
              </el-tooltip>
              <span class="todo-center"></span>
              <el-tooltip class="item" effect="dark" content="编辑" placement="bottom-end">
                <i class="icon WSiconfont WSicon-a-EditSquare1" @click="handleEdit(scope.$index, scope.row)" />
              </el-tooltip>
              <span v-if="!isSpace" class="todo-center"></span>
              <el-tooltip v-if="!isSpace" class="item" effect="dark" content="删除" placement="bottom-end">
                <i class="icon WSiconfont WSicon-shanchu" @click="handleDelete(scope.$index, scope.row)" />
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="AppManager-list-footer">
          <span>
            合计：{{ orgTotal }} 人
          </span>
          <el-pagination @current-change="handleOrgUserChange" @size-change="handleSizeChange"
            v-model:current-page="currentPageOrg" :page-size="userChangePage" :page-sizes="[20, 100, 500]" background
            layout="prev, pager, next, jumper, sizes" style="margin-top: 10px" :total="departmentDatas.total"
            v-if="departmentDatas && departmentDatas.total > 10">
          </el-pagination>
        </div>
      </div>
      <div class="AppManager-list" v-loading="loadingUser" v-show="!departmentShow">
        <!--组织结构子部门-->
        <el-table :data="subdivisionDatas" @row-click="loadChildData" border :stripe="true"
          :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }"
          :header-cell-class-name="'headerTopClass'" size="mini" :row-class-name="tableRowClassName"
          cell-class-name="cell_style">
          <el-table-column label="子部门" prop="name"> </el-table-column>
          <el-table-column prop="orders" label="排序"> </el-table-column>
        </el-table>
      </div>
    </div>
    <!--角色-->
    <div class="rightAppManager" v-show="!orgShow" v-loading="loadingUser" :style="{ height: isViewTitle ? '' : '100%' }">
      <div class="AppManager-title">
        <div class="buttonArea" style="padding-left: 0"
          :style="roleMsg.pid == 0 || adminUser ? 'width:100%' : 'width: calc(100% - 260px)'">
          <el-alert :closable="false" title="“主管”为默认角色，无法编辑， 请到部门设置中设置主管，设置完成后自动同步" type="warning" show-icon></el-alert>
        </div>
        <div class="buttonArea" v-if="!adminUser && roleMsg.pid !== 0">
          <el-button type="danger" @click="handleDeleteRole(-1, -1)">删除</el-button>
          <el-button type="primary" @click="adduserEvent(3)">新增组织用户</el-button>
        </div>
        <span class="buttonRightArea" v-if="!adminUser && false">
          显示
          <el-select v-model="userChooseRole" placeholder="请选择" size="mini" @change="userChooseEvent(1)">
            <el-option label="包含子角色成员" :value="0"> </el-option>
            <el-option label="不包含子角色成员" :value="1"> </el-option>
          </el-select>
        </span>

      </div>
      <div class="AppManager-list" v-show="adminUser">
        <el-table :data="roleDatas.data" border :stripe="true"
          :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }"
          :header-cell-class-name="'headerTopClass'" size="mini" :row-class-name="tableRowClassName"
          cell-class-name="cell_style">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="realname" label="姓名"></el-table-column>
          <el-table-column prop="orgname" label="主管部门"></el-table-column>
        </el-table>
        <el-pagination @current-change="handleRoleUserChange" v-model:current-page="currentPageRole" :page-size="10" background layout="prev, pager, next, jumper" :total="roleDatas.total" v-if="roleDatas && roleDatas.total > 10"></el-pagination>
      </div>
      <div class="AppManager-list" v-show="!adminUser">
        <el-table :data="roleDatas.data" border :stripe="true"
          :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }" style="width: 100%"
          @selection-change="roleChange" :row-class-name="tableRowClassName" header-cell-class-name="headerTopClass"
          cell-class-name="cell_style">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="姓名" prop="realname">
            <template v-slot="scope">
              {{ scope.row.realname }}
              <el-tag type="warning" size="small" v-show="scope.row.major != ''">主管</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="orgname" label="所在部门"></el-table-column>
          <el-table-column prop="username" label="用户名"></el-table-column>
        </el-table>
        <div class="AppManager-list-footer">
          <span>
            合计：{{ roleTotal }} 人
          </span>
          <el-pagination @current-change="handleRoleUserChange" v-model:current-page="currentPageRole" :page-size="10"
            background layout="prev, pager, next, jumper" :total="roleDatas.total"
            v-if="roleDatas && roleDatas.total > 10"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 新建用户侧滑 -->
    <el-drawer :style="{ '--el-drawer-padding-primary': 0 }" append-to-body v-model="addUserVisible" size="480"
      :show-close="false" title="新增（修改用户）">
      <template #title>
        <div class="user-edit-header">
          <span>
            新增（修改用户）
          </span>
          <i class="iconfont icon-guanbi" @click="addUserVisible = false"></i>
        </div>
      </template>
      <el-scrollbar style="height: calc(100% - 60px)">
        <el-form :model="addUserForm" label-position="left" ref="addUserForm" label-width="80px" class="user-edit-form">
          <el-form-item label="用户名" prop="username" :rules="[
            {
              required: addUserForm.userId ? false : true,
              message: '用户名不能为空',
              trigger: 'false',
            },
          ]">
            <el-input v-model="addUserForm.username" placeholder="请输入用户名" @blur="checkName"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="realname" :rules="[
            { required: true, message: '姓名不能为空', trigger: 'false' },
          ]">
            <el-input v-model="addUserForm.realname" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="身份" prop="type" :rules="[
            { required: true, message: '请选择身份', trigger: 'false' },
          ]">
            <el-select v-model="addUserForm.type" placeholder="请选择身份" style="width: 345px;" filterable remote
              reserve-keyword :remote-method="getIdentityList" :loading="identityLoading">
              <el-option v-for="list in identityList" :key="list.userTipId" :label="list.name" :value="list.keytype" />
            </el-select>
          </el-form-item>
          <el-form-item label="密码" prop="password" :rules="[
            {
              required: addUserForm.userId ? false : true,
              message: '密码不能为空',
              trigger: 'false',
            },
          ]">
            <el-input style="width:258px" v-model="addUserForm.password" ref="password" type="password"
              placeholder="请输入密码"></el-input>
            <el-button size="mini" @click="onRsetPassword">重置密码</el-button>
          </el-form-item>
          <el-form-item label="证件类型" prop="idcardtype">
            <el-select v-model="addUserForm.idcardtype" size="small" placeholder="请选择证件类型">
              <el-option v-for="item in identityTypes" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="idcard" :rules="userFormConfigRules.idcard">
            <el-input v-model="addUserForm.idcard" @blur="idUpperCase" @focus="clearVal('idcard')"
              :placeholder="addUserForm.userId ? addUserForm.idcards : '请输入证件号码'"></el-input>
            <span class="input-tips">证件号为该成员的平台登录账号，请按正式信息输入</span>
          </el-form-item>
          <el-form-item label="性别" prop="sex" style="margin-top: 12px">
            <el-select v-model="addUserForm.sex" placeholder="请选择性别" style="width:100%">
              <el-option label="男" :value="0">男</el-option>
              <el-option label="女" :value="1">女</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone" :rules="userFormConfigRules.phone">
            <el-input v-model="addUserForm.phone" @focus="clearVal('phone')"
              :placeholder="addUserForm.userId ? addUserForm.phones : '请输入手机号码'"></el-input>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker v-model="addUserForm.birthday" type="date" value-format="YYYY-MM-DD" format="YYYY-MM-DD"
              placeholder="请选择出生日期" />
          </el-form-item>
          <el-form-item label="组织" prop="organizations">
            <div class="choice-dept-role" @click="openOrg(0)">
              <el-tag v-for="(item, i) in selectGroup.checkedFlowArr" :key="i" effect="dark">
                {{ item.name }}
              </el-tag>
              <p v-if="selectGroup.checkedFlowArr.length == 0">请选择所在组织</p>
            </div>
          </el-form-item>
          <el-form-item label="角色" prop="roles">
            <div class="choice-dept-role" @click="openRole(0)">
              <el-tag v-for="(item, i) in selectGroup.checkedRoleArr" :key="i" effect="dark">
                {{ item.name }}
              </el-tag>
              <p v-if="selectGroup.checkedRoleArr.length == 0">请选择角色</p>
            </div>
          </el-form-item>
          <el-form-item v-if="isSpace" label="平台角色" prop="ptrole">
            <div class="choice-dept-role" @click="openSpaceRole()">
              <el-tag v-for="(item, i) in selectSpaceGroup.checkedSpaceRoleArr" :key="i" effect="dark">
                {{ item.name }}
              </el-tag>
              <p v-if="selectSpaceGroup.checkedSpaceRoleArr.length == 0">请选择角色</p>
            </div>
          </el-form-item>
          <el-form-item label="激活" prop="status" :rules="[
            { required: true, message: '请选择是否激活', trigger: 'false' },
          ]">
            <el-radio-group v-model="addUserForm.status">
              <el-radio :value="1">激活</el-radio>
              <el-radio :value="0">不激活</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序" prop="orders">
            <inputOrder v-model:model="addUserForm.orders"></inputOrder>
          </el-form-item>
          <el-form-item label="头像" prop="avatar">
            <el-upload class="avatar-uploader" :action="$imgurl + '/confile/upload?accesstoken=' + token"
              :show-file-list="false" :on-success="handleAvatarSuccess" :on-remove="handleRemove" :limit="2">
              <img v-if="dealDefaultAvatar" :src="dealDefaultAvatar" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="人脸照片" v-if="isShowFace">
            <div class="face-box">
              <img class="default-face" v-if="faceImgList.length === 0"
                src="https://bigdata.topeti.com/PCRepository/mainPlatform/face.png">
              <ul class="face-list" v-else>
                <li v-for="(item, index) in faceImgList" :key="index">
                  <img class="default-face" :src="item.url">
                  <span class="img-mask">
                    <i @click="handleFaceRemove(item, index)" class="WSiconfont WSicon-shanchu" />
                  </span>
                </li>
              </ul>
              <el-upload class="face-uploader" ref="faceUpload"
                :action="$imgurl + '/api/uploadface?accesstoken=' + token" multiple :on-success="handleFaceSuccess"
                :on-error="handleFaceError" :limit="9">
                <template #tip>
                  <div v-if="faceImgList.length === 0" class="el-upload__tip"> 支持jpg/jpeg/png图片格式，文件小于2M， 建议上传清晰照片，光线充足。
                  </div>
                </template>
                <el-button :style="faceImgList.length === 0 ? '' : { position: 'relative', top: '20px' }"
                  :loading="faceCheck">{{ faceCheck ? '图片识别中' : '上传图片' }}</el-button>
              </el-upload>
            </div>
          </el-form-item>
          <!-- 占位用的 -->
          <el-form-item>
            <div></div>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <div class="user-edit-footer">
        <el-button type="danger" @click="delUser(addUserForm)" v-if="deleteShow && !isSpace" :disabled="isDelUser"
          v-loading="isDelUser" plain size="mini">永久删除</el-button>
        <el-button type="danger" @click="newRoleDel(addUserForm)" v-if="deleteShow && !isSpace" plain size="mini">删
          除</el-button>
        <el-button size="mini" @click="newRoleReset('addUserForm')">取 消</el-button>
        <el-button size="mini" type="primary" :disabled="btnDisabaled" @click="newRoleSubmit('addUserForm')">保
          存</el-button>
      </div>
    </el-drawer>
    <!-- 批量修改部门 -->
    <el-dialog title="批量修改部门" v-model="departmentChangeVisible" width="400px" header-class="dialognewclass-header"
      body-class="dialognewclass-body" footer-class="dialognewclass-foot" :close-on-click-modal="false">
      <el-form :model="departmentChangeForm" ref="departmentChangeForm" label-width="80px" class="newgroupBody">
        <el-form-item label="上级部门" prop="pid">
          <p class="choice-dept" @click="parentBusiness(5)">
            {{ departmentChangeForm.pName }}
          </p>
        </el-form-item>
      </el-form>
      <template #footer>
        <span>
          <el-button size="mini" type="primary" @click="departmentChangeSubmit">保 存</el-button>
          <el-button size="mini" type="plain" @click="departmentChangeVisible = false">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 添加子部门 -->
    <el-dialog title="添加子部门" v-model="popupDeptAddShow" width="400px" header-class="dialognewclass-header"
      body-class="dialognewclass-body" footer-class="dialognewclass-foot" :close-on-click-modal="false">
      <el-form :model="popupDeptForm" ref="popupDeptForm" label-width="80px" class="newgroupBody">
        <el-form-item label="部门名称" prop="name" :rules="[
          { required: true, message: '部门名称不能为空', trigger: 'blur' },
        ]">
          <el-input v-model="popupDeptForm.name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="pid">
          <p class="choice-dept" @click="parentBusiness(1)">
            {{ popupDeptForm.pName == "" ? "请选择上级" : popupDeptForm.pName }}
          </p>
        </el-form-item>
        <el-form-item label="排序" prop="orders">
          <inputOrder v-model:model="popupDeptForm.orders"></inputOrder>
        </el-form-item>
        <el-form-item label="激活" prop="status">
          <el-radio-group v-model="popupDeptForm.status">
            <el-radio :label="1">激活</el-radio>
            <el-radio :label="0">不激活</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <span>
          <el-button type="yeprimary" @click="popupAddSubmit('popupDeptForm')">保 存</el-button>
          <el-button type="plain" @click="popupDeptAddShow = false">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 编辑部门 -->
    <el-dialog title="编辑部门" v-model="popupDeptEditShow" width="400px" header-class="dialognewclass-header"
      body-class="dialognewclass-body" footer-class="dialognewclass-foot" :close-on-click-modal="false">
      <el-form :model="opupDeptEditForm" ref="opupDeptEditForm" label-width="80px" class="newgroupBody">
        <el-form-item label="部门名称" prop="name" :rules="[
          { required: true, message: '部门名称不能为空', trigger: 'blur' },
        ]">
          <el-input v-model="opupDeptEditForm.name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="pid">
          <p class="choice-dept" @click="parentBusiness(0)">
            {{ opupDeptEditForm.pid == 0 ? "最上级" : opupDeptEditForm.pName }}
          </p>
        </el-form-item>
        <el-form-item label="排序" prop="orders">
          <inputOrder v-model:model="opupDeptEditForm.orders"></inputOrder>
        </el-form-item>
        <el-form-item label="设置主管" prop="name">
          <div class="choice-dept" @click="setSuperiorUser()" style="padding: 0px 5px">
            <p v-if="
              opupDeptEditForm.muser && opupDeptEditForm.muser.length == 0
            ">
              选填
            </p>
            <p v-else class="span-user" style="text-align: left">
              <span v-for="(item, index) in opupDeptEditForm.muser" :key="index" v-show="index < 3">{{
                index > 1 ? (index == 2 ? item.name + "等人" : "") : item.name
              }}</span>
            </p>
          </div>
        </el-form-item>
        <el-form-item label="激活" prop="status">
          <el-radio-group v-model="opupDeptEditForm.status">
            <el-radio :label="1">激活</el-radio>
            <el-radio :label="0">不激活</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <span>
          <el-button size="mini" type="primary" @click="popupEditSubmit('opupDeptEditForm')">保 存</el-button>
          <el-button size="mini" type="plain" @click="popupDeptEditShow = false">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <orgChoice ref="orgChoiceRef" :curSpace="curSpaceInfo" :isSpace="isSpace" v-on:fromMultipleChoice="orgChoiceMethod">
    </orgChoice><!--组织选择框-->
    <org-user-group-choice ref="orgUserNameGroupChoice"
      v-on:orgUserGroupNameMethod="orgUserNameGroupMethod"></org-user-group-choice><!--设置主管-->
    <!-- 用户导入导出 -->
    <org-import v-model:isView="popupBatchAddDept" :keyList="keyList" type="user"></org-import>
    <!-- 批量添加(童) -->
    <batch-create v-model:batch="batchShow" v-model:datas="batchDatas" :type="batchDatasType" v-if="batchShow"
      @batchClose="batchClose" />
    <!-- 批量添加学校部门(大刘) -->
    <pikaluonti ref="pikaluontiRefs" :datas="pikaluontiDatas" v-if="pikaluontiShow"
      @closePikaluonti="closePikaluonti" />
    <!-- 组织的操作 -->
    <org-set ref="orgSet" @success='partialRefresh()' />
    <!-- excel录入用户 -->
    <batchJexcel v-if="jexcel" v-model:jexcel="jexcel" :jexcelBatch="jexcelBatch" :type="orgMsg.type || 0"
      :id="orgMsg.organizationId || 0" @retBatchJexcel="retBatchJexcel" />
    <!-- 二维码邀请加入 -->
    <el-dialog v-model="qrcode.visible" width="281px" title="邀请用户" header-class="dialognewclass-header"
      body-class="dialognewclass-body" footer-class="dialognewclass-foot" class="dialognewclass"
      :style="{ '--el-dialog-padding-primary': '0px' }">
      <div class="qr-code">
        <div class="row-switch">
          允许二维码加入
          <el-switch :active-value="1" :inactive-value="0" v-model="qrcode.open" @change="onchangeqrcode"></el-switch>
        </div>
        <div class="row-switch">
          允许用户授权手机号
          <el-switch :active-value="1" :inactive-value="0" v-model="openphone" @change="onchangephone"></el-switch>
        </div>
        <div>
          <img :src="$imgurl + qrcode.qrcode" v-if="qrcode.open === 1" />
          <img v-else src="https://bigdata.topeti.com/PCRepository/defaultSvg/other.svg" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { axiosBase } from "@/api/api";
import { authentication } from '@/api/utils'
import { iphone } from "@/util/util"
import orgChoice from '../../common/multipleChoice'
import orgUserGroupChoice from './orgUserGroupChoice'
import { getpwdconfig } from "@/port/pages/login";
import { adsolutedeleteuser, unbindopenid, getusertiplist, getnoopenusertiplist } from '@/port/admins/organizationUser'
import { getorganization } from '@/port/admins/organizationSpace'
import jsonType from '@/api/userConfig'
import treeMixins from './common/common.js'
import { typeObj } from '@/util/constants'
import { getdepttiplist } from '@/port/admins/organizationUser'
import treeMinix from './mixins/tree.js' // 中台协同网络的操作
import { formatDate, getOrgShowName } from "@/api/global.js";
import { updateuserorders } from '@/port/admins/organizationSpace'
import * as faceapi from 'face-api.js';
import { defineAsyncComponent } from "vue";
export default {
  name: 'organizationUser',
  data() {
    // - 身份证验证方法
    const validateIdcard = (rule, value, callback) => {
      if (!value) return callback()
      // 如果是修改并且值为空的话不验证
      if (this.addUserForm.userId && this.addUserVisible.idcard === value) return callback()
      const typeNumber = this.addUserForm.realIdcard ? this.addUserForm.realIdcard : this.addUserForm.idcardtype ? this.addUserForm.idcardtype : 1
      const returnValue = authentication(typeNumber || 0, value)
      if (typeof returnValue === 'boolean' && returnValue === true) {
        // 如果是居民身份证并且
        if (this.addUserForm.idcardtype === 1 && this.addUserForm.idcard) {
          const idcard = (this.addUserForm.idcard).includes('***') && this.addUserForm.realIdcard ? this.addUserForm.realIdcard : this.addUserForm.idcard
          this.addUserForm.birthday = this.getBirthday(idcard)
          this.addUserForm.sex = parseInt(idcard.substr(16, 1)) % 2 === 1 ? 0 : 1
        }
        callback()
      } else if (typeof value === 'string' && value.includes('***')) {
        callback()
      } else {
        return callback(new Error(returnValue || '身份证格式不正确'))
      }
    }
    // - 电话号码验证方法
    const validatePhone = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error('电话号码内容不能空'))
      // }
      if (!value) return callback()
      // 如果是修改并且值为空的话不验证
      if (this.addUserForm.userId && this.addUserForm.phone === value) return callback()
      // - 需要验证
      const returnValue = iphone(value)
      if (returnValue === true) {
        callback()
      } else {
        return callback(new Error('请输入正确的电话号码!'))
      }
    }
    const keyP = 'password'
    return {
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      isDelUser: false,
      orgShow: true,
      departmentShow: true,//组织结构成员与子门面切换
      addUserVisible: false,
      addUserForm: {
        username: '',
        [keyP]: 'aa123456',
        realname: '',
        sex: 0,
        type: 0,
        status: '',
        avatar: '',
        birthday: ''
      },
      selectGroup: {//选择组织跟角色
        checkedFlow: [],
        checkedFlowArr: [],
        checkedRoleArr: [],
        checkedRole: [],
        isEquired: true
      },
      selectSpaceGroup: {//组织空间配置的角色
        spaceRoleArr: [], //配置的角色
        checkedSpaceRoleArr: [], //已选择的角色
        checkedSpaceRole: [], //已选择的角色Role id
      },
      isSpaceCheck: false, //是否在组织空间配置平台角色
      orgChoiceKey: 0,//组织结构得KEY值0--选择上级部门 --1添加子部门  --2管理范围  --3角色添加部门  --4添加成员所在部门  --
      departmentChangeVisible: false,//批量修改部门
      departmentChangeForm: {//批量修改上级部门
        pName: '请选择上级部门'
      },
      userChooseOrg: true,//显示，部门用户筛选
      userChooseRole: true,//显示，角色用户筛选
      //以下3个table参数
      departmentDatas: [],//部门成员
      departmentcheck: [],//部门成员选中
      subdivisionDatas: [],//子部门
      subdivisionCheck: [],//子部门选中
      roleDatas: [],//角色
      roleCheck: [],//角色选中
      organizationId: null,//组织架构ID
      userMsg: null,//角色ID参数
      currentPageOrg: 1,//组织架构当前页
      currentPageRole: 1,//角色当前页

      adminUser: true,//默认和管理员用户
      //添加子部门
      popupDeptAddShow: false,
      popupDeptForm: { name: '', pName: '请选择上级', pid: '', status: 1, orders: '' },
      orgMsg: { name: '' },//组织全局信息
      roleMsg: { name: '' },//角色全局信息

      popupDeptEditShow: false,//修改部门名称
      opupDeptEditForm: { pid: '' },
      opupDeptEditFormOld: null,
      searchLoadDataPsParmChIsBan: false,
      deleteShow: true,
      whetherChange: false,//- 组织架构上级调换
      userChangePage: 20, // 分页条
      user: localStorage.getItem("user"),
      search: 'names', // 搜索
      isZt: false,  // 是否中台来打开（因为中台打开过来的是固定url）
      // 身份证类型
      identityTypes: [
        {
          label: '居民身份证',
          value: 1
        },
        {
          label: '香港特区护照/身份证明',
          value: 2
        },
        {
          label: '澳门特区护照/身份证明',
          value: 3
        },
        {
          label: '台湾居民来往大陆通行证',
          value: 4
        },
        {
          label: '境外永久居住证',
          value: 5
        },
        {
          label: '其他',
          value: 6
        }
      ],
      // 用户表格配置
      userConfig: [
        {
          label: 'ID',
          props: 'userId',
          width: '70px'
        },
        {
          label: '姓名',
          props: 'realname',
          width: '76px'
        },
        {
          label: '证件号码',
          props: 'idcard',
          width: '141px'
        },
        {
          label: '性别',
          props: 'sex',
          width: '49px',
          options: jsonType.gender,
          optionsProps: 'label',
          optionsIndex: 0
        },
        {
          label: '排序',
          props: 'orders',
          width: '88px'
        },
        // {
        //   label: '出生日期',
        //   props: 'birthday',
        //   width: '88px'
        // },
        {
          label: '身份',
          props: 'type',
          options: {},
          // options: jsonType.identity,
          width: '66px',
          // optionsProps: 'label',
          // optionsIndex: 0
        },
        {
          label: '组织',
          props: 'orgname',
          width: '150px'
        },
        {
          label: '角色',
          props: 'rolename',
          width: '200px'
        },
        {
          label: '最后登录时间',
          props: 'logintime',
          width: '160px',
        }
      ],
      // 验证
      userFormConfigRules: {
        idcard: [
          { validator: validateIdcard, trigger: 'blur' },
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' },
        ]
      },
      // 身份列表
      identityList: [],
      identityLoading: false,
      identityObj: null,
      searchWd: '',
      loadingUser: false,
      userSerchData: [],
      groupSerchData: [],
      isSearch: false,
      searchLoading: false, // 搜索的loading
      //  打开批量弹窗
      popupBatchAddDept: false,
      organizationType: [],
      // 组织操作当前节点
      currentNode: '',
      // 批量录入
      jexcel: false,
      jexcelBatch: '',
      // 邀请加入二维码
      qrcode: { visible: false },
      openphone: 0, //允许用户授权手机号
      isMoveOrg: 0, // 是否是调动组织 0 不是 1 调动组织 2 调入本组织
      btnDisabaled: false, // 是否可以提交
      faceImgList: [], // 人脸列表
      DelFaceImgList: [], // 删除的人脸列表
      isShowFace: true, // 人脸功能
      isSpace: this.$route.path === '/spaceMain/user',
      spaceid: this.$route.query.spaceid || localStorage.getItem('spaceid'),
      curSpaceInfo: {},
      treekey: 0,
      defaultShowNodes: [],
      keyList: [], //完整身份列表
      // 第三方接入用户使用参数
      logVisible: false,
      orgTotal: 0, // 组织类型下的用户总数
      roleTotal: 0, // 类型下的用户总数
      pwdconfig: {}, // 密码安全设置
      // 未登录查询相关配置
      showRestBtn: false,
      nologinCheck: '',
      faceCheck: false, //认识照片识别状态
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', '近一周');
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', '近一个月');
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', '近三个月');
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
            picker.$emit('pick', '近半年');
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', '近一年');
          }
        }]
      },

      upOrganizationId: '',
      orgId: ''
    }

  },
  props: {
    isAppenTitle: {
      type: Boolean,
      default: true
    },
  },
  components: {
    orgChoice,
    orgUserGroupChoice,
    breadCrubm: defineAsyncComponent(() => import('./common/breadCrubm.vue')),
    search: defineAsyncComponent(() => import('./common/search.vue')),
    orgImport: defineAsyncComponent(() => import('./common/orgImport.vue')),
    orgSet: defineAsyncComponent(() => import('./common/orgSet')),
    batchJexcel: defineAsyncComponent(() => import('./common/batchJexcel.vue')),
    inputOrder: defineAsyncComponent(() => import('./common/inputOrder.vue')),
  },
  mixins: [treeMixins, treeMinix],
  created() {
    console.log(this.$route, 'asdasda');
    const path = this.$route.path
    if (path && path === '/admins/organization/organizationUsers') this.isZt = true;
    this.getNooPenIdentityList()
    this.getOrganizationType()
    if (this.isSpace) {
      this.getCurSpaceInfo()
    }

  },
  computed: {
    isViewTitle() {
      return this.$route.path !== '/organizationUser' || this.isAppenTitle
    },
    dealDefaultAvatar() {
      let avatar = this.addUserForm.avatar
      let url = ''
      if (avatar) {
        if (avatar.includes('img-')) {
          url = this.$imgurl + avatar
        } else {
          const list = avatar.split('/')
          const num = list[list.length - 1]
          let format = `${num}.jpg`
          if (Number(num) >= 36) {
            format = `${num}.svg`
          }
          url = `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
        }
      } else {
        if (this.addUserForm.sex && this.addUserForm.sex === '女') {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
        } else {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
        }
      }
      return url
    },
  },
  methods: {
    dealShowName(data) {
      return getOrgShowName(data)
    },
    upOrgId(val) {
      if (val < 0) {
        this.$message.warning('排序不能小于0！！')
        this.orgId = 0
      }
    },
    async upSort(data) {
      this.orgId = data.orders || 0
      this.upOrganizationId = data.userId
      await this.$nextTick()
      setTimeout(() => {
        const dom = this.$refs['id' + data.userId]
        if (dom && dom[0] || dom) (dom && dom[0] || dom).focus()
      }, 10)
    },
    async upSortFun(data) {
      const ob = { userId: data.userId, orders: this.orgId || 0 }
      const { code, msg } = await updateuserorders(ob).catch(err => { console.log(err) })
      if (code === 0) {
        this.$message.success(msg || '修改成功！')
        this.handleOrgUserChange(this.currentPageOrg)
        this.upOrganizationId = ''
        this.orgId = ''
      } else {
        this.$message.error(msg || '修改失败!')
      }
    },
    async getCurSpaceInfo() {
      if (!this.spaceid) return
      const { code, data } = await getorganization({
        organizationId: this.spaceid
      })
      if (code === 0) {
        this.curSpaceInfo = data
        this.treekey++
      }
    },
    // 添加人脸
    async setFace(userId) {
      // 如果存在待删列表就循环删除
      if (this.DelFaceImgList.length > 0) {
        const faceUrls = []
        this.DelFaceImgList.forEach(e => {
          faceUrls.push(e.faceUrl)
        })
        const obj = {
          userId,
          faceUrls
        }
        if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
        await axiosBase(obj, '/api/deletefacerecord')
      }
      // 循环上传
      for (let index = 0; index < this.faceImgList.length; index++) {
        const e = this.faceImgList[index];
        if (!e.faceInfo) continue
        if (!e.faceId) {
          let faceImg = e.fpath ? '/userfiles/faceavatar/' + e.fpath : e.faceUrl
          const obj = {
            faceUrl: faceImg,
            feature: e.faceInfo,
            userId
          }
          if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
          // 上传人脸图片
          const res = await axiosBase(obj, '/api/addfacerecord')
          if (res.code == 0) {
            console.log("res--上传成功", index);
          } else {
            this.$message.error(res.msg)
          }
        }
      }
    },

    // 人脸特征值
    async fetchAndProcessImage(imageUrl, fpath) {
      if (imageUrl) {
        const img = await faceapi.fetchImage(imageUrl);
        // console.log("img==",img);
        this.faceCheck = true
        const detectionOptions = new faceapi.SsdMobilenetv1Options({
          minConfidence: 0.25, // 以控制需要检测到人脸的最小置信度分数。
          minFaceSize: 100, // 参数以检测较小的人脸
          maxFaceSize: 300, // 参数以检测较大的人脸
        });
        const detections = await faceapi.detectAllFaces(img, detectionOptions).withFaceLandmarks().withFaceDescriptors();
        console.log("detections==", detections);
        if (detections.length == 1) {
          const descriptorArray = Object.values(detections[0].descriptor);
          this.faceImgList.push({
            url: imageUrl,
            fpath: fpath,
            faceInfo: descriptorArray
          })
          console.log("this.faceImgList--", this.faceImgList);
        }
        else if (detections.length == 0) {
          this.$message.error("未检测到人脸")
        }
        else {
          this.$message.error("检测到多张人脸,请重新上传单个人脸的照片")
        }
        this.faceCheck = false
      }
    },
    // 组织空间获取分配角色信息
    async getUserRole(channel) {
      let userMsg = localStorage.getItem("userMsg");
      if (userMsg) {
        userMsg = JSON.parse(userMsg);
        const obj = {
          schoolId: userMsg.schoolMsg.schoolId
        }
        const { code, data } = await axiosBase(obj, '/api/getschool')
        if (code === 0 && data.signrole) {
          const roleList = JSON.parse(data.signrole)
          this.selectSpaceGroup.spaceRoleArr = roleList
          if (channel === 'addUser') {
            this.selectSpaceGroup.checkedSpaceRoleArr = roleList.filter(e => e.checked === true)
            this.selectSpaceGroup.checkedSpaceRoleArr.forEach(element => {
              this.selectSpaceGroup.checkedSpaceRole.push(element.roleId)
            });
          }
        }
      }
    },
    // 获取人脸照片
    async getFace(userId) {
      const obj = {
        userId
      }
      if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
      const { data } = await axiosBase(obj, '/api/getuserfacephotos')
      if (data && data.length > 0) {
        this.faceImgList = data.map(e => {
          let str = e.faceUrl
          let userInfo = JSON.parse(localStorage.getItem('user'));
          str = str.replace('userfiles', 'confiles')
          e.url = this.$url + '/' + str + '?accesstoken=' + userInfo.accesstoken
          return e
        })
      }
    },
    // 检查用户名是否可用
    async checkName() {
      if (this.addUserForm.username === '' || !this.deleteShow) return this.btnDisabaled = false
      const obj = {
        username: this.addUserForm.username
      }
      if (this.addUserForm.userId) obj.userId = this.addUserForm.userId
      if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
      const { code, msg } = await axiosBase(obj, 'api/validateusername')
      if (code == 0) {
        this.btnDisabaled = false
      } else {
        this.btnDisabaled = true
        this.$message.error(msg)
      }
    },
    // 表格颜色
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'row_style';
      } else {
        return '';
      }
    },
    // 顶部按钮功能
    topBtnHandle(id) {
      if ([2, 4, 5, 6, 8].indexOf(id) !== -1 && this.orgMsg.organizationId == undefined) return this.$message.info('请先选择组织！')
      switch (id) {
        case 0: {
          // 新建用户或者组织
          this.btnDisabaled = false
          this.adduserEvent(this.departmentShow ? 0 : 1)
          break;
        }
        case 1: {
          // 导入导出
          this.openImp()
          break;
        }
        // excel复制
        case 2: {
          this.jexcelBatch = 'user'
          this.jexcel = true
          break;
        }
        // 批量删除
        case 3: {
          this.handleDelete(-1, -1)
          break;
        }
        // 设置管理员
        case 4: {
          const obj = []
          if (this.departmentcheck.length === 0) return this.$message.info('请选择用户')
          this.departmentcheck.forEach(e => {
            obj.push({
              realname: e.realname,
              userId: e.userId
            })
          })
          this.setAdmintor(this.orgMsg.organizationId, obj)
          break;
        }
        // 邀请加入
        case 5: {
          this.onOpenQrcode()
          break;
        }
        // 从本部门移除
        case 6: {
          this.delDepartmentUser()
          break;
        }
        // 调入其他组织
        case 7: {
          if (this.departmentcheck.length === 0) return this.$message.info('请选择用户')
          this.isMoveOrg = 1
          this.$refs.orgChoiceRef.multipleChoiceMethod({ isEquired: false, apiurl: true, isrole: true, isuser: true, checkedFlowArr: [] });
          break;
        }
        // 调入本组织
        case 8: {
          this.isMoveOrg = 2
          this.$refs.orgChoiceRef.multipleChoiceMethod({ apiurl: true, checkedFlow: [], checkedFlowArr: [], isEquired: true });
          break;
        }
        // 未登录查询
        case 9: {
          this.$refs.datepicke.focus();
          break;
        }
        // 重置选中用户密码
        case 10: {
          this.handleResetPsw(-1)
          break;
        }
        // 重置所有用户密码
        case 11: {
          console.log("重置所有用户密码");
          this.handleResetPsw(1)
          break;
        }
      }
    },
    // 处理组织
    dealOrg(data, node, type) {
      // 0新增下级组织 1编辑组织信息 2删除组织
      this.currentNode = node
      switch (type) {
        case 0: {
          // 新建下级组织
          const obj = {
            name: '',
            pid: data.organizationId,
            pName: data.name,
            orders: 0,
            status: 1,
            admintor: [],
            muser: [],
            type: ''
          }
          this.$refs.orgSet.open({
            data: obj,
            isLevelAdd: true,
            title: `新增${data.name}下级组织`
          })
          break;
        }
        case 1: {
          // 编辑组织信息
          const obj = {
            name: data.name,
            orders: data.orders,
            pid: data.pid,
            pName: data.pName || '',
            status: data.status,
            type: data.type,
            organizationId: data.organizationId,
            looktype: data.looktype,
            muser: data.muser ? JSON.parse(data.muser) : [],
            admintor: data.admintor ? JSON.parse(data.admintor) : []
          }
          this.$refs.orgSet.open({
            data: obj,
            isEdit: true,
            title: '编辑组织'
          })
          break;
        }
        case 2: {
          const tip = `确定要删除"${data.name}"组织?`
          // 删除
          this.$confirm(tip, '提示', {
            confirmButtonClass: 'el-button--yeprimary',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const obj = { organizationId: data.organizationId }
            if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
            axiosBase(obj, "/api/deleteorganization").then(res => {
              if (res.code == 0) {
                this.$message({ type: "success", message: "删除成功!" });
                // 刷新数据
                this.partialRefresh()
              } else {
                this.$message({ type: "info", message: res.msg });
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
          break;
        }
      }
    },
    // 调入其他组织 | 调入本组织
    async moveOrgCallBack(param, type) {
      console.log(type)
      let obj = {
        organizationId: this.orgMsg.organizationId,
      }
      if (type === 1) {
        if (param.checkedFlowArr.length === 0) return this.$message.info('请选择组织')
        obj.anotherId = param.checkedFlowArr[0].organizationId,
          obj.userids = this.departmentcheck.map(item => item.userId).join(',')
      } else if (type === 2) {
        if (param.checkedArrUser.length === 0) return this.$message.info('请选择用户')
        const userArr = []
        param.checkedArrUser.forEach(e => {
          userArr.push({
            name: e.realname,
            userId: e.userId
          })
        })
        obj.data = JSON.stringify(userArr)
      }
      const url = type === 1 ? '/api/transferdept' : type === 2 ? '/api/addfromotherdept' : ''
      if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
      const res = await axiosBase(obj, url)
      this.$message(res.msg)
      if (res.code === 0) {
        this.thisTreeUserCh(this.orgMsg)
      }
    },
    // 邀请加入
    async onOpenQrcode() {
      if (this.qrcode.qrcode) {
        this.qrcode.visible = true
        return false
      }
      const _par = { organizationId: this.orgMsg.organizationId }
      if (this.isSpace && this.spaceid) _par.spaceid = this.spaceid
      const res = await axiosBase(_par, '/api/createrweima')
      this.qrcode = res.code === 0 ? { ...res.data, visible: true } : this.qrcode

      const __par = { organizationId: this.orgMsg.organizationId }
      if (this.isSpace && this.spaceid) __par.spaceid = this.spaceid
      const resOrg = await axiosBase(__par, '/api/getorganization')
      if (resOrg.code === 0 && resOrg.data.openphone !== undefined) {
        this.openphone = resOrg.data.openphone
      }
    },
    // 从本部门移除
    delDepartmentUser() {
      if (this.departmentcheck.length === 0) return this.$message.info('请选择用户')
      this.$confirm('确认将这批用户移出本组织？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const __par = { organizationId: this.orgMsg.organizationId, data: JSON.stringify(this.departmentcheck) }
        if (this.isSpace && this.spaceid) __par.spaceid = this.spaceid
        const res = await axiosBase(__par, '/api/deletefromdept')
        if (res.code === 0) {
          this.$message.success('移除成功！')
          this.thisTreeUserCh(this.orgMsg)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        })
      })
    },
    // 允许二维码加入
    async onchangeqrcode(key) {
      const __par = { organizationId: this.orgMsg.organizationId, open: key, qrcode: '' }
      if (this.isSpace && this.spaceid) __par.spaceid = this.spaceid
      const res = await axiosBase(__par, '/api/updateopen')
      this.qrcode = res.code === 0 ? { ...res.data, visible: true } : this.qrcode
    },
    // 允许用户授权手机号
    async onchangephone(key) {
      const _par = { organizationId: this.orgMsg.organizationId, openphone: key }
      if (this.isSpace && this.spaceid) _par.spaceid = this.spaceid
      const res = await axiosBase(_par, '/api/updateorg')
      if (res.code === 0) {
        const __par = { organizationId: this.orgMsg.organizationId }
        if (this.isSpace && this.spaceid) __par.spaceid = this.spaceid
        const res = await axiosBase(__par, '/api/getorganization')
        this.openphone = res.data.openphone
      }
    },
    // 设置管理员
    async setAdmintor(id, data) {
      const obj = {
        organizationId: id,
        admintor: data
      }
      if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
      const { code, msg } = await axiosBase(obj, '/api/updateorganization')
      if (code === 0) {
        this.$message.success('设置成功')
      } else {
        this.$message.error('设置失败' + msg)
      }
    },
    // excel成功
    retBatchJexcel() {
      this.jexcel = false
      this.thisTreeUserCh(this.orgMsg)
    },
    // 局部刷新方法
    partialRefresh(node) {
      node = this.currentNode ? this.currentNode : node
      // 新增或修改时,更新当前节点
      node.loaded = false
      node.loadData() // 重新查询当前节点的所有子元素

      // 删除时, 更新父级节点
      node.parent.loaded = false
      node.parent.loadData()
    },
    // 获取组织类型
    async getOrganizationType() {
      const __par = {
        curpage: 1,
        pagesize: 9999
      }
      if (this.spaceid && this.isSpace) __par.spaceid = this.spaceid
      const { data, code, msg } = await getdepttiplist(__par)
      if (code === 0) {
        this.organizationType = data
      } else {
        this.$message.error(msg)
      }
    },
    // 组织类型色卡
    labelView({ val, type }) {
      const itype = this.organizationType.find(item => item.deptTipId === val) || {}
      if (itype.deptTipId > 9) {
        return typeObj[itype.colours] && typeObj[itype.colours][type]
      } else {
        return typeObj[itype.deptTipId] && typeObj[itype.deptTipId][type]
      }
    },
    dealType(type) {
      const itype = this.organizationType.find(item => item.deptTipId === type) || {}
      return itype.name
    },
    // 批量导入导出
    openImp() {
      this.popupBatchAddDept = true
    },
    // 查看搜索结果
    resultClick(i, data) {
      // 组织
      if (i == 0) {
        this.organizationId = data.organizationId
        this.handleOrgUserChange(1)
      } else { // 角色
        this.thisTreeUserCh(data)
      }
    },
    // 角色和组织搜索回调
    async searchCallBack() {
      if (this.searchWd === '') return this.$meaasge.info('关键字不能为空！')
      this.searchLoading = true
      this.groupSerchData = []
      this.userSerchData = []

      const url = this.orgShow ? '/api/getorganizationlist' : '/api/getrolelist'
      const userObj = { curpage: 0, pagesize: 0, [this.search]: this.searchWd }
      const groupBbj = { curpage: 0, pagesize: 0, name: this.searchWd }
      if (this.isSpace && this.spaceid) {
        userObj.spaceid = this.spaceid
        groupBbj.spaceid = this.spaceid
        userObj.organizationsId = this.spaceid
      }
      const groupRes = await axiosBase(groupBbj, url)
      const userRes = await axiosBase(userObj, '/api/getuserlist')
      // 搜索组织或者角色
      if (groupRes.code == 0) {
        if (groupRes.data.length > 0) {
          this.groupSerchData = groupRes.data
          this.isSearch = true
        }
      } else {
        this.$message.error('搜索失败')
      }
      if (this.isSpace && this.orgShow) {
        this.groupSerchData = []
      }
      // 搜索用户
      if (userRes.code == 0) {
        if (userRes.data.length > 0) {
          this.userSerchData = userRes.data
          this.isSearch = true
          this.searchTotal = userRes.total
        }
      } else {
        this.$message.error('用户搜索失败')
      }

      if (this.groupSerchData.length === 0 && this.userSerchData.length === 0) {
        this.$message.warning('暂无数据!')
        this.isSearch = false
      }
      this.searchLoading = false
    },
    // 获取身份列表
    async getIdentityList(val) {
      console.log('获取搜索数据', val)
      const obj = { curpage: 1, pagesize: 999999 }
      if (val) obj.name = val
      if (this.spaceid && this.isSpace) obj.spaceid = this.spaceid
      const res = await getusertiplist(obj)
      if (res.code === 0) {
        this.identityList = res.data
        if (!this.identityObj) {
          const identityObj = {}
          const i = (this.userConfig).findIndex(item => item.props === 'type')
          for (const a of res.data) {
            identityObj[a.keytype] = a.name
          }
          if (i !== -1) this.userConfig[i].options = identityObj
        }
      }
    },
    // 获取身份列表
    async getNooPenIdentityList() {
      const obj = { curpage: 1, pagesize: 999999 }
      if (this.spaceid && this.isSpace) obj.spaceid = this.spaceid
      const res = await getnoopenusertiplist(obj)
      if (res.code === 0) {
        const identityObj = {}
        const i = (this.userConfig).findIndex(item => item.props === 'type')
        for (const a of res.data) {
          identityObj[a.keytype] = a.name
          this.keyList = res.data
        }
        if (i !== -1) this.userConfig[i].options = identityObj
      }
    },
    // 头像图片上传成功
    handleAvatarSuccess(res) {
      this.addUserForm.avatar = '/confiles/' + res
    },
    // 人脸图片上传成功
    handleFaceSuccess(res) {
      let userInfo = JSON.parse(localStorage.getItem('user'))
      const imgUrl = this.$url + '/confiles/faceavatar/' + res + '?accesstoken=' + userInfo.accesstoken
      this.fetchAndProcessImage(imgUrl, res)
    },
    // 人脸删除
    handleFaceRemove(data, index) {
      // 存在id就是已经注册的照片
      if (data.faceUrl) {
        // 保存的时候删除用
        this.DelFaceImgList.push(data)
      }
      this.faceImgList.splice(index, 1)
    },
    // 人脸上传失败
    handleFaceError() {
      this.$meaasge.error('照片上传失败')
    },
    // 根据身份证号获取出生年月日
    getBirthday(idcard) {
      if (!idcard) return ''
      return idcard.substring(6, 10) + '-' + idcard.substring(10, 12) + '-' + idcard.substring(12, 14)
    },
    // 微信解绑
    uniteWx(e) {
      if (!e.openid) return false
      const self = this
      this.$confirm('请确认是否解绑微信？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const __par = { userId: e.userId }
        if (this.spaceid && this.isSpace) __par.spaceid = this.spaceid
        const res = await unbindopenid(__par)
        if (res.code === 0) {
          self.$message.success(res.msg)
          self.handleOrgUserChange(1)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        })
      })
    },
    delUser(val) {
      const self = this
      this.$confirm('确认将用户永久删除？', '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.$confirm('用户永久删除后，数据将无法恢复，确认吗？', '提示', {
          confirmButtonClass: 'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.delUserFun(val)
        })
      })
    },
    delUserFun(val) {
      this.loading = true
      this.isDelUser = true
      const __par = { uid: val.userId }
      if (this.spaceid && this.isSpace) __par.spaceid = this.spaceid
      adsolutedeleteuser(__par).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.addUserVisible = false; //关闭弹窗
          if (this.organizationId) {
            this.handleOrgUserChange(this.currentPageOrg);
          }
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
        this.isDelUser = false
      }).catch(err => {
        console.log(err)
      })
    },
    handleSizeChange(val) {
      this.userChangePage = val;
      this.handleOrgUserChange(1);
    },
    adduserEvent(item) {
      this.deleteShow = false;
      this.DelFaceImgList = []
      this.faceImgList = []
      this.selectGroup = {//选择组织跟角色
        checkedFlow: [],
        checkedFlowArr: [],
        checkedRoleArr: [],
        checkedRole: [],
        isEquired: true
      };
      if (this.isSpace) {
        this.getUserRole("addUser")
      }
      if (item == 0) {//组织架构添加成员
        const keyP = 'password'
        if (this.orgMsg.name && this.orgMsg.organizationId) {
          this.selectGroup.checkedFlow.push(this.orgMsg.organizationId)
          this.selectGroup.checkedFlowArr.push({ name: this.orgMsg.name, organizationId: this.orgMsg.organizationId })
        }
        this.addUserVisible = true;
        this.addUserForm = {
          username: '',
          [keyP]: 'aa123456',
          realname: '',
          // sex:0,
          type: 0,
          status: 1,
          avatar: '',
        }
        if (JSON.stringify(this.pwdconfig) !== '{}' && this.pwdconfig.pwdlevel.password) {
          this.addUserForm.password = this.pwdconfig.pwdlevel.password
        }
        this.getIdentityList()
      } else if (item == 1) {//组织架构添加子部门
        this.popupDeptAddShow = true
        this.popupDeptForm = { name: '', pName: '请选择上级', pid: '', status: 1, orders: '' }
      } else {//角色得新增成员
        this.orgChoiceKey = 3;
        this.isMoveOrg = 0
        this.$refs.orgChoiceRef.multipleChoiceMethod({ onlyUser: true, isorgs: true, apiurl: true });
      }
      //   value.forEach(b => {
      //   checkedFlow.push(b.id)
      //   checkedFlowArr.push({name:b.name,organizationId:b.id})
      // });

    },
    departmentChangeEvent() {//批量修改部门
      if (this.departmentcheck.length > 0) {
        this.departmentChangeVisible = true
      } else {
        this.$message({ type: "info", message: "请选择用户!" });
        return;
      }
    },

    departmentChangeSubmit() {

    },

    handleEdit(index, row) {
      this.btnDisabaled = false
      this.DelFaceImgList = []
      this.faceImgList = []
      if (this.isShowFace) {
        this.getFace(row.userId)
      }
      if (row.roles && row.roles != "") {
        this.selectGroup.checkedRole = row.roles.split(',').map(Number)
        var b = row.rolename.split(',');
        this.selectGroup.checkedRoleArr = [];
        this.selectGroup.checkedRole.forEach((e, i) => {
          this.selectGroup.checkedRoleArr.push({ name: b[i], roleId: e })
        });
      } else {
        this.selectGroup.checkedRoleArr = [];
        this.selectGroup.checkedRole = [];
      }
      // 组织空间配置平台角色
      if (this.isSpace) {
        this.getUserRole("editUser")
        this.selectGroup.checkedRoleArr = []
        this.selectGroup.checkedRole = []
        this.selectSpaceGroup.checkedSpaceRoleArr = []
        this.selectSpaceGroup.checkedSpaceRole = []
        if (row.spacerole && row.spacerole.length > 0) {
          this.selectGroup.checkedRoleArr = row.spacerole
          this.selectGroup.checkedRoleArr.forEach(element => {
            this.selectGroup.checkedRole.push(element.roleId)
          });
        }
        if (row.pingtairole && row.pingtairole.length > 0) {
          this.selectSpaceGroup.checkedSpaceRoleArr = row.pingtairole
          this.selectSpaceGroup.checkedSpaceRoleArr.forEach(element => {
            this.selectSpaceGroup.checkedSpaceRole.push(element.roleId)
          });
        }
      }
      if (row.organizations && row.organizations != "") {
        this.selectGroup.checkedFlow = row.organizations.split(',').map(Number)
        let b = row.orgname ? row.orgname.split(',') : '';
        this.selectGroup.checkedFlowArr = [];
        this.selectGroup.checkedFlow.forEach((e, i) => {
          this.selectGroup.checkedFlowArr.push({ name: b[i], organizationId: e })
        });
      } else {
        this.selectGroup.checkedFlowArr = [];
        this.selectGroup.checkedFlow = []
      }
      // 修改身份证和手机号另存
      if (row.idcard) {
        row.idcards = row.idcard
        // row.idcard = ''
      }
      if (row.phone) {
        row.phones = row.phone
        // row.phone = ''
      }
      this.addUserForm = JSON.parse(JSON.stringify(row));
      this.getIdentityList()
      this.addUserVisible = true;
    },
    handleDelete(index, row, popupDel) {
      //popupDe这个参数是0树形结构搜索用户
      var userId = [];
      if (index == -1) {//批量删除
        if (this.departmentcheck.length > 0) {
          this.departmentcheck.forEach(e => {
            userId.push(e.userId)
          })
        } else {
          this.$message({ type: "info", message: "请选择需要删除的用户!" });
          return;
        }
      } else {
        userId = row.userId
      }
      this.$confirm(`确定要删除${row.realname ? '"' + row.realname + '"' : '选中的用户'}?`, '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        const __par = { uid: userId }
        if (this.isSpace && this.spaceid) {
          __par.spaceid = this.spaceid
        }
        axiosBase(__par, "/api/deleteuser").then(res => {
          if (res.code == 0) {
            this.$message({ type: "success", message: "删除成功!" });
            this.handleOrgUserChange(this.currentPageOrg);
            if (popupDel == '0') {
              this.addUserVisible = false; //关闭弹窗
              if (this.orgShow) {
                this.$refs.organizationUserTreePs.searchLoadDataPsParmCh();
              } else {
                this.$refs.organizationUserTreePs1.searchLoadDataPsParmCh();
              }
            }
          } else {
            this.$message({ type: "info", message: "删除失败!" });
          }
          this.loading = false;
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDeleteRole(index, row) {
      var userId = null;
      if (index == -1) {//批量删除
        if (this.roleCheck.length > 0) {
          var userIds = []
          this.roleCheck.forEach(e => {
            userIds.push(e.userId)
          });
          userId = userIds.join(',')
        } else {
          this.$message({ type: "info", message: "请选择需要移除的用户!" });
          return;
        }
      } else {
        userId = row.userId
      }
      this.$confirm('确定要移除该用户?', '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        const __par = { roleId: this.roleMsg.roleId, userIds: userId }
        if (this.isSpace && this.spaceid) {
          __par.spaceid = this.spaceid
        }
        axiosBase(__par, "/api/removerolefromuser").then(res => {
          this.loading = false
          if (!res || res.code != 0) {
            this.$message({ type: "info", message: "移除失败!" });
          } else {
            this.$message({ type: "success", message: "移除成功!" });
            this.handleRoleUserChange(this.currentPageRole)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        });
      });
    },
    newRoleReset(formName) {
      this.$refs[formName].resetFields();
      this.addUserVisible = false;
      this.searchLoadDataPsParmChIsBan = false;
    },
    newRoleDel(formName) {
      this.handleDelete(0, formName, 0);
    },
    popupDeptEditEvent(i) {
      if (i == 0) {//编辑部门
        if (!this.opupDeptEditForm.pid && this.opupDeptEditForm.pid !== 0) {
          this.$message({
            type: 'info',
            message: '请选择组织机构'
          });
          return
        }
        this.popupDeptEditShow = true
      } else {
        // TODO
      }
    },
    setSuperiorUser() {
      this.$refs.orgUserNameGroupChoice.orgGroupNameChoiceMethod(this.opupDeptEditForm);
    },
    orgUserNameGroupMethod(param) {
      if (param.checkedFlowArr) {
        var superiorArr = [];
        param.checkedFlowArr.forEach((el) => {
          var obj = {};
          obj.name = el.realname;
          obj.userId = el.userId;
          superiorArr.push(obj);
        });
        this.opupDeptEditForm.muser = superiorArr;
      } else {
        this.opupDeptEditForm.muser = [];
      }
    },
    newRoleSubmit(formName) {
      // 这里验证要临时转下数据（手机号和证件号码的）
      // if (this.addUserForm.userId) {//修改
      //   if (this.addUserForm.idcards && this.addUserForm.idcards === this.addUserForm.idcard) delete this.addUserForm.idcard
      //   if (this.addUserForm.phones && this.addUserForm.phones === this.addUserForm.phone) delete this.addUserForm.phone
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addUserForm.password && this.addUserForm.password !== '') {
            if (this.addUserForm.password.length < 8) {
              this.isLoading = false
              this.$message.info('密码长度少于8位')
              return;
            }
            if (JSON.stringify(this.pwdconfig) !== '{}') {
              // 密码强度验证
              switch (this.pwdconfig.pwdlevel.level) {
                case 1:
                  {
                    let regx = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,12}$")
                    if (!regx.test(this.addUserForm.password)) {
                      this.$message.info("密码必须包含英文（含大小写）+ 数字 + 特殊字符")
                      return
                    }
                  }
                  break;
                case 2:
                  {
                    let regx = new RegExp("^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,12}$")
                    if (!regx.test(this.addUserForm.password)) {
                      this.$message.info("密码必须包含英文+ 数字 + 特殊字符")
                      return
                    }
                  }
                  break;
                case 3:
                  {
                    let regx = /^(?=.*[a-zA-Z])(?=.*\d).{8,12}$/
                    if (!regx.test(this.addUserForm.password)) {
                      this.$message.info("密码必须包含英文+ 数字")
                      return
                    }
                  }
                  break;
                default:
                  break;
              }
            }
            else {
              let regx = /^(?=.*[a-zA-Z])(?=.*\d).{8,12}$/
              if (!regx.test(this.addUserForm.password)) {
                this.$message.info("密码必须包含英文+ 数字")
                return
              }
            }
          }
          if (this.selectGroup.checkedFlowArr.length > 0) {
            var organizations = {};
            this.selectGroup.checkedFlow.forEach(i => {
              organizations['organization' + i] = ""
            });
            this.addUserForm.organizations = JSON.stringify(organizations)
          } else {
            this.$message({
              type: 'info',
              message: '所在部门不能为空'
            });
            return;
          }
          if (this.selectGroup.checkedRoleArr.length > 0 || this.selectSpaceGroup.checkedSpaceRoleArr.length > 0) {
            var roles = {};
            if (this.selectGroup.checkedRoleArr.length > 0) {
              this.selectGroup.checkedRole.forEach(j => {
                roles['role' + j] = ""
              });
            }
            if (this.selectSpaceGroup.checkedSpaceRoleArr.length > 0) {
              this.selectSpaceGroup.checkedSpaceRole.forEach(j => {
                roles['role' + j] = ""
              });
            }
            this.addUserForm.roles = JSON.stringify(roles)
          } else {
            this.addUserForm.roles = ''
          }
          this.loading = true
          if (this.addUserForm.listschool) {
            delete this.addUserForm.listschool;
          }
          if (this.addUserForm.role) {
            delete this.addUserForm.role;
          }
          if (this.addUserForm.ptrole) {
            delete this.addUserForm.ptrole;
          }
          if (this.addUserForm.spacerole) {
            delete this.addUserForm.spacerole;
          }
          if (this.addUserForm.pingtairole) {
            delete this.addUserForm.pingtairole;
          }
          if (this.addUserForm.organization) {
            delete this.addUserForm.organization;
          }
          if (this.addUserForm.userId) {//修改
            if (this.addUserForm.orders && this.addUserForm.orders != '') {
              this.addUserForm.orders = parseInt(this.addUserForm.orders)
            }
            delete this.addUserForm.roleorg
            // 有编辑过密码，但是密码为空，则不传
            if (Object.prototype.hasOwnProperty.call(this.addUserForm, 'password') && this.addUserForm.password.length === 0) {
              delete this.addUserForm.password
            }
            // 修改身份证手机没改动则不传
            if (this.addUserForm.idcards && this.addUserForm.idcards === this.addUserForm.idcard) delete this.addUserForm.idcard
            if (this.addUserForm.phones && this.addUserForm.phones === this.addUserForm.phone) delete this.addUserForm.phone
            delete this.addUserForm.phones
            delete this.addUserForm.idcards
            const addUser = JSON.parse(JSON.stringify(this.addUserForm))
            if (this.isSpace && this.spaceid) {
              addUser.spaceid = this.spaceid
            }
            if (this.faceCheck) {
              this.$message({
                type: 'info',
                message: '人脸照片上传中,请稍后保存'
              });
              return false;
            }
            axiosBase(addUser, "/api/updateuser").then(res => {
              if (!res || res.code != 0) {
                this.loading = false
                if (res.msg === '手机号已被占用') {
                  this.$message({
                    type: 'info',
                    message: '手机号已被绑定'
                  });
                } else {
                  this.$message({
                    type: 'info',
                    message: '修改失败'
                  });
                }
              } else {//修改成功
                if (this.orgShow) {

                  //更新数据，搜索的数据
                  if (this.isSearch) {
                    this.searchCallBack()
                  }
                  else {
                    // 如果是搜索修改用户数据，调用该接口会报错，先做判断，只有非搜索的时候才调用（双十bug）
                    this.handleOrgUserChange(1);
                  }
                  // if (this.searchLoadDataPsParmChIsBan) {
                  //   this.$refs.organizationUserTreePs.searchLoadDataPsParmCh();
                  // }
                } else {
                  //更新数据，搜索的数据
                  if (this.isSearch) {
                    this.searchCallBack()
                  }
                  else {
                    this.handleRoleUserChange(1);
                  }
                  // if (this.searchLoadDataPsParmChIsBan) {
                  //   this.$refs.organizationUserTreePs1.searchLoadDataPsParmCh();
                  // }
                }
                this.searchLoadDataPsParmChIsBan = false;
                this.setFace(this.addUserForm.userId)
                this.loading = false
                this.addUserVisible = false

              }

            });
          } else {//新增
            const addUser = JSON.parse(JSON.stringify(this.addUserForm))
            if (this.isSpace && this.spaceid) {
              addUser.spaceid = this.spaceid
            }
            axiosBase(addUser, "/api/adduser").then(res => {
              if (!res || res.code != 0) {
                this.$message({
                  type: 'info',
                  message: '新增失败'
                });
              } else {//新增成功
                if (this.organizationId) {
                  this.handleOrgUserChange(1)
                }
                if (res.data) {
                  this.setFace(res.data)
                }
                this.addUserVisible = false
              }
              this.loading = false
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleControlLimit(index, row) {//角色得管理范围
      console.log(row);
      var value = [];
      for (var e in row.roleorg) {
        value = row.roleorg[e];
      }

      var checkedFlow = []
      var checkedFlowArr = []
      value.forEach(b => {
        checkedFlow.push(b.id)
        checkedFlowArr.push({ name: b.name, organizationId: b.id })
      });
      this.userMsg = row;
      this.orgChoiceKey = 2
      this.isMoveOrg = 0
      this.$refs.orgChoiceRef.multipleChoiceMethod({ apiurl: true, checkedFlow: checkedFlow.map(Number), checkedFlowArr: checkedFlowArr, isEquired: true });
    },
    parentBusiness(val) {//上级部门选择
      this.orgChoiceKey = val
      if (val == 0) {//修改上级部门
        var organIdArr = []
        organIdArr.push(this.opupDeptEditForm.organizationId)
        this.isMoveOrg = 0
        this.$refs.orgChoiceRef.multipleChoiceMethod({ apiurl: true, orgRadio_: true, checkedList: organIdArr, isEquired: true });
      } else {//添加上级部门
        this.isMoveOrg = 0
        this.$refs.orgChoiceRef.multipleChoiceMethod({ apiurl: true, orgRadio_: true, isEquired: val == 5 ? false : true });
      }

    },
    //重置密码
    onRsetPassword() {
      this.addUserForm.password = this.pwdconfig.pwdlevel.password
    },
    openOrg() {
      this.isMoveOrg = 0
      this.orgChoiceKey = 4;
      this.$refs.orgChoiceRef.multipleChoiceMethod({ isEquired: false, apiurl: true, isrole: true, isuser: true, checkedFlowArr: this.selectGroup.checkedFlowArr });
    },
    orgChoiceMethod(param) {//组织选择
      if (this.isSpaceCheck) { // 组织空间配置平台角色
        this.isSpaceCheck = false;
        this.spaceRoleChoiceMethod(param)
        return
      }
      if (this.isMoveOrg === 1 || this.isMoveOrg === 2) { // 调动组织选择 //调入本组织选择
        this.moveOrgCallBack(param, this.isMoveOrg)
        return
      }
      if (param.key && param.key === 'role') { //如果是角色选择
        this.roleChoiceMethod(param)
        return
      }
      if (this.orgChoiceKey == 0) {
        if (param.checkedFlowArr.length > 0) {
          this.opupDeptEditForm.pName = param.checkedFlowArr[0].name
          //- 判断是否是组织还是角色表单一级类数据展示
          if (param.checkedFlowArr[0].organizationId != this.opupDeptEditForm.pid) {
            //- 说明组织结构上级有变换
            this.whetherChange = true;
          } else {
            this.whetherChange = false;
          }
          this.opupDeptEditForm.pid = param.checkedFlowArr[0].organizationId
        } else {
          this.opupDeptEditForm.pName = ''
          this.opupDeptEditForm.pid = 0
        }
      } else if (this.orgChoiceKey == 1) {
        if (param.checkedFlowArr.length > 0) {
          this.popupDeptForm.pName = param.checkedFlowArr[0].name
          this.popupDeptForm.pid = param.checkedFlowArr[0].organizationId
        } else {
          this.popupDeptForm.pName = ''
          this.popupDeptForm.pid = 0
        }
      } else if (this.orgChoiceKey == 2) {//设置管理范围
        let orgId = []
        param.checkedFlowArr.forEach(element => {
          orgId.push(element.organizationId)
        });
        orgId = orgId.join(',')
        this.loading = true;
        const __par = { userId: this.userMsg.userId, roleId: this.roleMsg.roleId, organizationIds: orgId }
        if (this.isSpace && this.spaceid) __par.spaceid = this.spaceid
        axiosBase(__par, "/api/setcontrollerbyuseridandroleid").then(res => {
          this.loading = false;
          if (!res || res.code != 0) {
            this.$message({ type: "info", message: "管理范围设置失败!" });
          } else {
            this.$message({ type: "success", message: "管理范围设置成功!" });
            this.handleRoleUserChange(this.currentPageRole)
          }
        });
      } else if (this.orgChoiceKey == 3) {
        let userid = []
        param.checkedArrUser.forEach(element => {
          userid.push(element.userId)
        });
        userid = userid.join(',')
        this.loading = true;
        const __par = { userIds: userid, roleId: this.roleMsg.roleId }
        if (this.isSpace && this.spaceid) __par.spaceid = this.spaceid
        axiosBase(__par, "/api/addrolefromuser").then(res => {
          this.loading = false;
          if (!res || res.code != 0) {
            this.$message({ type: "info", message: res.msg + "!" });
          } else {
            this.$message({ type: "success", message: "新增成功!" });
            this.handleRoleUserChange(this.currentPageRole)
          }
        });
      } else if (this.orgChoiceKey == 4) {
        this.selectGroup.checkedFlow = [];
        this.selectGroup.checkedFlowArr = param.checkedFlowArr;
        param.checkedFlowArr.forEach(element => {
          this.selectGroup.checkedFlow.push(element.organizationId)
        });
      }
    },
    openRole() {
      this.isMoveOrg = 0
      this.$refs.orgChoiceRef.multipleChoiceMethod({ checkedRoleArr: this.selectGroup.checkedRoleArr, key: 'role', isEquired: true, isorgs: true, isuser: true, apiurl: true });
    },
    // 打开平台角色
    openSpaceRole() {
      const obs = {
        checkedRoleArr: this.selectSpaceGroup.checkedSpaceRoleArr,
        lookCustomArrRole: this.selectSpaceGroup.spaceRoleArr,
        key: 'role',
        isEquired: true,
        isorgs: true,
        isuser: true,
        apiurl: true,
        hideChangeRole: true
      }
      this.isSpaceCheck = true;
      this.isMoveOrg = 0
      this.$refs.orgChoiceRef.multipleChoiceMethod(obs);
    },
    roleChoiceMethod(param) {
      this.selectGroup.checkedRole = []
      this.selectGroup.checkedRoleArr = param.checkedRoleArr;
      param.checkedRoleArr.forEach(element => {
        this.selectGroup.checkedRole.push(element.roleId)
      });
    },
    spaceRoleChoiceMethod(param) {
      this.selectSpaceGroup.checkedSpaceRole = []
      this.selectSpaceGroup.checkedSpaceRoleArr = param.checkedRoleArr;
      param.checkedRoleArr.forEach(element => {
        this.selectSpaceGroup.checkedSpaceRole.push(element.roleId)
      });
    },
    departmentChange(val) {
      this.departmentcheck = val
    },
    roleChange(val) {
      this.roleCheck = val
    },
    userChooseEvent(i) {
      if (i == 0) {
        this.handleOrgUserChange(1)
      } else {
        this.handleRoleUserChange(1)
      }
    },
    handleOrgUserChange(val) {//组织结构用户信息获取
      console.log('查询', val)
      this.currentPageOrg = val
      this.loadingUser = true;
      var param = {}
      if (this.userChooseOrg) {
        param = { organizationsId: this.organizationId, curpage: val, pagesize: this.userChangePage }
        // param = {organizationsId:this.organizationId,curpage:val,pagesize:10}
      } else {
        param = { organizationId: this.organizationId, curpage: val, pagesize: this.userChangePage }
      }
      if (this.isSpace && this.spaceid) param.spaceid = this.spaceid
      axiosBase(param, "/api/getuserlist").then(res => {
        if (res) {
          this.departmentDatas = res
          this.orgTotal = res.total
          this.departmentDatas.data.map(item => {
            if (item.logintime) {
              let date = new Date(item.logintime);
              item.logintime = formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            }
            return item
          });
        }
        this.loadingUser = false
      });
    },
    handleRoleUserChange(val) {//角色用户信息数据获取
      this.loadingUser = true
      this.currentPageRole = val
      // this.loading=true;
      var param = {}
      if (this.userChooseRole) {
        param = { rolesId: this.roleMsg.roleId, curpage: val, pagesize: 10 }
      } else {
        param = { roleId: this.roleMsg.roleId, curpage: val, pagesize: 10 }
      }
      if (this.isSpace && this.spaceid) param.spaceid = this.spaceid
      axiosBase(param, "/api/getuserlist").then(res => {
        if (res) {
          this.roleDatas = res
          this.loadingUser = false
          this.roleTotal = res.total
        }
        // this.loading=false;
      });
    },
    popupAddSubmit(formName) {//添加子部门
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.popupDeptForm.orders && this.popupDeptForm.orders !== '') {
            this.popupDeptForm.orders = parseInt(this.popupDeptForm.orders)
          }
          const popupDeptForm = JSON.parse(JSON.stringify(this.popupDeptForm))
          if (this.isSpace && this.spaceid) popupDeptForm.spaceid = this.spaceid
          axiosBase(popupDeptForm, "/api/addorganization").then(res => {
            this.loading = false;
            if (res.code == 0) {
              this.$message({ type: "success", message: "新增成功!" });
              this.popupDeptAddShow = false;
            } else {
              this.$message({ type: "info", message: "新增失败!" });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    popupEditSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          var param = {};
          param.organizationId = this.opupDeptEditForm.organizationId;
          param.pid = this.opupDeptEditForm.pid;
          param.name = this.opupDeptEditForm.name;
          param.status = this.opupDeptEditForm.status;
          if (this.opupDeptEditForm.orders && this.opupDeptEditForm.orders != '') {
            param.orders = parseInt(this.opupDeptEditForm.orders)
          }
          var muserSrt = this.opupDeptEditForm.muser;
          param.muser = JSON.stringify(muserSrt);
          if (this.isSpace && this.spaceid) param.spaceid = this.spaceid
          axiosBase(param, "/api/updateorganization").then(res => {
            this.loading = false;
            if (res.code == 0) {
              this.orgMsg.name = param.name
              this.orgMsg.status = param.status
              this.$message({ type: "success", message: "编辑成功!" });
              this.popupDeptEditShow = false;
              //静态数据更新
              if (this.opupDeptEditForm.muser != this.opupDeptEditFormOld.muser) {
                this.opupDeptEditFormOld.muser = this.opupDeptEditForm.muser;
                this.thisTreeUserCh(this.opupDeptEditFormOld);
              }
              //- whetherChange判断是否上级部门变换
              if (this.whetherChange == true) {
                this.$refs.organizationUserTreePs.updateTreeFun();
                this.whetherChange = false;
              }
            } else {
              this.$message({ type: "info", message: "编辑失败!" });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    thisTreeUserCh(data, isType) {
      if (isType == '1') {
        this.handleEdit(0, data);
        this.searchLoadDataPsParmChIsBan = true;
      } else {
        this.opupDeptEditFormOld = data;
        if (data.organizationId) {
          this.popupDeptForm.pName = data.name;
          this.popupDeptForm.pid = data.organizationId;
        }
        this.opupDeptEditForm = JSON.parse(JSON.stringify(data))
        if (typeof this.opupDeptEditForm.muser == "string") {
          this.opupDeptEditForm.muser = JSON.parse(data.muser)
        }
        if (data.roleId) {//如果角色信息
          this.roleMsg = data
          if ((data.type == 1 || data.type == 3) && JSON.parse(this.user).isadmin != 1) {
            this.adminUser = true
          } else {
            this.adminUser = false
          }
          this.currentPageRole = 1;
          this.handleRoleUserChange(1)
        } else if (data.organizationId) {//否则有组织结构ID就是组织结构信息
          this.orgMsg = data
          this.organizationId = data.organizationId
          this.currentPageOrg = 1;
          this.handleOrgUserChange(1)
          // 用户显示子部门
          const obj = {
            curpage: 0,
            pagesize: 0,
            pid: data.organizationId
          }
          if (this.isSpace && this.spaceid) obj.spaceid = this.spaceid
          axiosBase(
            obj,
            "/api/getorganizationlist"
          ).then(res => {
            if (res.code == 0) {
              this.subdivisionDatas = res.data
            } else {
              console.log('/api/getorganizationlist错误');
            }
          })
        }
      }
      this.showRestBtn = false
      // this.loading = false
    },
    loadChildData(row) {
      this.thisTreeUserCh(row)
    },
    //头像专用
    getFile(file) {
      this.getBase64(file.raw).then(res => {
        this.addUserForm.avatar = res.split(",")[1]
      });
    },
    handleRemove() {
      this.addUserForm.avatar = '';
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    handleRefresh() {
      this.logVisible = false
    },
    // 证件号码强制大写
    idUpperCase() {
      this.addUserForm.idcard = this.addUserForm.idcard.toUpperCase()
    },
    // 证件号/手机号,如果包含*，则清空该值
    clearVal(val) {
      if (this.addUserForm[val].includes('*')) {
        this.addUserForm[val] = ''
      }
    },
    // 未登录查询修改日期
    changeTime(dateVal) {
      var param = {}
      if (this.userChooseOrg) {
        param = { organizationsId: this.organizationId, curpage: 1, pagesize: this.userChangePage, nologin: dateVal }
      } else {
        param = { organizationId: this.organizationId, curpage: 1, pagesize: this.userChangePage, nologin: dateVal }
      }
      if (this.isSpace && this.spaceid) param.spaceid = this.spaceid
      axiosBase(param, "/api/getuserlist").then(res => {
        if (res.code === 0) {
          this.showRestBtn = true
          this.departmentDatas = res
          this.orgTotal = res.total
          this.departmentDatas.data.map(item => {
            if (item.logintime) {
              let date = new Date(item.logintime);
              item.logintime = formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            }
            return item
          });
        }
        else {
          this.$message.error(res.msg);
        }
        this.loadingUser = false
      });
    },
    handleResetPsw(index) {
      var userId = [];
      var __par = {}
      var tip = ''
      if (index == -1) {//重置选中用户密码
        if (this.departmentcheck.length > 0) {
          this.departmentcheck.forEach(e => {
            userId += e.userId + ','
          })
          __par = { userids: userId }
          tip = `本次重置 ${this.departmentcheck.length} 个用户登录密码，涉及用户平台使用， 请谨慎操作，点击确定后生效！`
        } else {
          this.$message({ type: "info", message: "请选择需要重置密码的用户!" });
          return;
        }
      }
      else if (index == 1) {//重置所有用户密码
        if (this.userChooseOrg) {
          __par = { organizationsId: this.organizationId, nologin: this.nologinCheck }
        } else {
          __par = { organizationId: this.organizationId, nologin: this.nologinCheck }
        }
        tip = `本次重置 ${this.orgTotal} 个用户登录密码，涉及用户平台使用， 请谨慎操作，点击确定后生效！`
      }

      // 删除
      this.$confirm(tip, '提示', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        if (this.isSpace && this.spaceid) {
          __par.spaceid = this.spaceid
        }
        axiosBase(__par, "/api/batchresetpassword").then(res => {
          if (res.code == 0) {
            this.$message({ type: "success", message: res.msg });
            this.handleOrgUserChange(this.currentPageOrg);
          } else {
            this.$message({ type: "info", message: res.msg });
          }
          this.loading = false;
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置密码'
        });
      });
    },
    //- 获取密码安全设置
    getpwdconfig() {
      let that = this;
      getpwdconfig().then(res => {
        if (res.code === 0 && res.data) {
          that.pwdconfig = JSON.parse(res.data)
          that.addUserForm.password = that.pwdconfig.pwdlevel.password
        } else {
          if (res.msg) {
            that.$message.error(res.msg);
          }
        }
      })
        .catch(error => {
          console.log(error);
        });
    },
    // 加载人脸模型文件
    async loadModels() {
      const MODEL_URL = '../../../../static/faceModels';
      try {
        await Promise.all([
          faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
          faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
          faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
          faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
        ]);
      } catch (error) {
        console.error('Failed to load models:', error);
      }
    },
  },
  mounted() {
    this.$emit('childKey', 2);
    //- 设置首页头部切换状态
    this.$store.commit('changeSelect', 4)
    // 获取密码密码安全设置
    this.getpwdconfig()
    this.loadModels()
  },
  watch: {
    addUserVisible(nEl) {
      if (!nEl) {
        this.deleteShow = true;
      } else {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.password.$refs.input.removeAttribute('readonly')
          }, 400);
        })
      }
    },
    searchWd: {
      handler(val) {
        // 清空搜索列表
        if (val === '') {
          this.isSearch = false
          this.groupSerchData = []
          this.userSerchData = []
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./css/common.scss";

.sort-input {
  width: 60px;

  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.organizationUser {
  width: 100%;
  height: 100%;

  .userManager-title {
    padding: 11px 7px 21px 7px;
  }

  .leftMenu {
    width: 330px !important;
    height: calc(100% - 50px);
    // height: calc(100% - 110px);
    background: #ffffff;
    overflow: hidden;
    display: inline-block;

    .search-wrap {
      display: flex;
      padding: 16px;
      justify-content: space-between;
      align-items: center;
    }

    .search-box {
      width: 170px;

      .search {
        width: 100% !important;
      }
    }

    .tapButtons {
      margin: 24px 0 16px 0;
      text-align: center;

      .tap-button {
        display: inline-block;
        border: 1px solid #F0F0F0;
        border-radius: 39px;
        text-align: center;
        padding: 6px 18px;
        background: #ffffff;
        cursor: pointer;
        color: #333333;

        &-left {
          border-radius: 39px 0 0 39px;
        }

        &-right {
          border-radius: 0 39px 39px 0;
          margin-left: -4px;
        }

        &.active {
          color: #fff;
          background-color: #4e86ff;
          border: 1px solid #4e86ff;

          &:hover {
            background-color: #719eff;
          }
        }
      }
    }

    ::v-deep .selectArea {
      width: 120px;

      .el-input__inner {
        border-radius: 50px;
        height: 32px;
      }

      .el-select__caret {
        line-height: 9px;
      }
    }

    .menuList {
      width: 100%;
      height: calc(100% - 180px);

      .orgBox,
      .roleBox {
        width: 100%;
        height: 100%;
      }

      .org-name {
        display: inline-block;
        max-width: 188px;
        overflow: hidden;
        vertical-align: text-top;
        text-overflow: ellipsis;
      }

      ::v-deep .el-tree-node .el-tree-node__content {
        height: 40px;

        // position: relative;
        .line {
          position: absolute;
          display: block;
          left: -32px;
          bottom: 12px;
          width: 13px;
          height: 500px;
          border-left: 1px solid #DDEDFB;
          border-bottom: 1px solid #DDEDFB;
        }

        .none-type {
          margin-left: 8px;
          display: inline-block;
          padding: 0 10px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 4px;
          background-color: rgba(225, 230, 235, 0.5);
          color: #adb0b2;
        }

        .more {
          position: absolute;
          right: 16px;
          top: 10px;
          display: none;
        }

        .icon-xiangqing {
          display: none;
          position: absolute;
          right: 8px;
        }

        &:hover {
          color: #38A2FB;
          background-color: #F5F8FA;

          & .icon-xiangqing {
            display: inline-block;
          }
        }
      }

      ::v-deep .el-tree-node.is-current>.el-tree-node__content {
        color: #38A2FB;
        background-color: #F5F8FA;
      }
    }
  }

  .rightAppManager {
    margin-left: -3px;
    width: calc(100% - 340px);
    // height: calc(100% - 30px);
    height: calc(100% - 49px);
    display: inline-block;
    vertical-align: top;
    background: #ffffff;

    .AppManager-title {
      overflow: hidden;
      padding: 24px 16px 16px 16px;
      display: flex;
      align-items: center;

      .goBack {
        display: inline-block;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .buttonArea {
      flex: 1;
      vertical-align: top;
      padding: 0px 3px;
      display: inline-block;

      ::v-deep .el-button {
        margin-left: -3px;
      }

      .buttonStyle {
        height: 49px;
        line-height: 49px;
        text-align: center;
        display: inline-block;
        vertical-align: top;
        margin-right: 20px;
        cursor: pointer;

        .blueColor {
          color: #4e86ff;
        }

        .redColor {
          color: #e47470;
        }

        i {
          display: inline-block;
          margin-right: 3px;
        }

        span {
          display: inline-block;
          vertical-align: top;
        }
      }
    }

    .buttonRightArea {
      float: right;
      margin-right: 11px;
    }

    .AppManager-list {
      width: calc(100% - 34px);
      padding-left: 16px;
      height: calc(100% - 85px);

      &-footer {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      ::v-deep .el-table {

        th,
        td {
          height: 40px;
          line-height: 1 !important;
          color: rgba(51, 57, 62, 1) !important;
        }

        .cell {
          line-height: 1 !important;
        }
      }

      // 表格样式
      ::v-deep .headerTopClass {
        background: rgb(234, 237, 242) !important;
        color: rgba(51, 57, 62, 1) !important;
        font-weight: 500 !important;
      }

      ::v-deep .row_style {
        background-color: #F8F9FB;
      }

      ::v-deep .cell_style {
        height: 40px;
      }

      ::v-deep .el-table--border td {
        border: none;
        background: none;
      }

      .todo-center {
        display: inline-block;
        width: 1px;
        background: #ebe8e1;
        height: 10px;
        margin: 0 5px;
      }

      .icon {
        font-size: 14px;
        cursor: pointer;
      }

      .WSicon-a-EditSquare1 {
        color: #4e86ff;
      }

      .WSicon-shanchu {
        color: #e47470;
      }
    }

    ::v-deep .el-pagination {
      text-align: right;
    }
  }
}

.dialognewclass {
  border-radius: 8px !important;
  overflow: hidden;

  .el-button--mini.is-circle {
    padding: 7px;
  }
}

::v-deep .dialognewclass-header {
  background-color: #fff;
  height: 58px;
  line-height: 58px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  padding: 0 20px;
}

::v-deep .dialognewclass-body {
  padding: 0 16px;
  background-color: rgba(250, 251, 252, 1);

  .el-form-item {
    margin-bottom: 20px !important;
  }
}

::v-deep .dialognewclass-foot {
  background-color: rgba(250, 251, 252, 1);
}

.choice-dept {
  color: rgba(214, 215, 216, 1);
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  padding-left: 16px;
  cursor: pointer;
  height: 32px;
  line-height: 32px;

  .span-user {
    color: #000000;

    span:not(:last-of-type):after {
      content: "，";
    }
  }
}

::v-deep .user-edit-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 480px !important;
  padding: 16px !important;
  box-sizing: border-box;

  .el-form-item {
    width: 100%;
    margin-bottom: 8px !important;
    position: relative;

    .input-tips {
      position: absolute;
      display: inline;
      line-height: 1;
      left: 0;
      bottom: -10px;
      font-size: 12px;
      color: #666666;
    }

    .el-form-item__error {
      background-color: #fff;
      width: 100%;
    }

    .el-form-item__label {
      color: rgba(51, 57, 62, 1);
      font-weight: 500;
    }

    .el-select,
    .el-date-editor {
      width: 345px;
    }

    .el-select,
    .el-input__icon {
      line-height: 32px;
    }

    .el-input {
      width: 345px;
      height: 32px !important;

      .el-input__inner {
        height: 32px !important;
      }
    }

    .input-order {
      width: 88px;
    }

    .el-form-item__error {
      padding-top: 0px;
      top: 38px
    }

    .avatar-uploader {
      width: 58px;
      height: 58px;
      background: #F7F8FA;
      border: 1px dashed #DCDEE0;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-upload {
        width: 100%;
        height: 100%;

        .el-icon-plus {
          width: 100%;
          height: 100%;
          line-height: 58px;
        }
      }
    }

    .face-box {
      display: flex;

      .face-list {
        display: flex;
        flex-wrap: wrap;

        li {
          position: relative;

          &:hover .img-mask {
            display: inline-block;
          }

          .img-mask {
            width: 76px;
            height: 76px;
            line-height: 76px;
            text-align: center;
            border-radius: 4px;
            position: absolute;
            left: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.6);
            display: none;

            i {
              cursor: pointer;
              color: #FFFFFF;
            }
          }
        }
      }

      .default-face {
        width: 76px;
        height: 76px;
        border-radius: 4px;
        margin-right: 4px;
      }

      .face-uploader {
        margin: 0 0 8px 4x;

        .el-upload-list {
          display: none
        }

        .el-upload {
          width: 74px;
          height: 32px;
          line-height: 40px
        }

        .el-upload--picture-card {
          background-color: none !important;
          border: none;
        }

        .el-upload__tip {
          font-size: 12px;
          line-height: 16px;
          color: #999999;
          font-family: PingFangSC-Regular;
          margin-top: 0px;
        }

        .el-upload-list {
          li {
            width: 76px;
            height: 76px;
            border-radius: 4px;
          }
        }
      }
    }

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }

    .choice-dept-role {
      width: 345px;
      height: 32px;
      padding: 0 16px;
      box-sizing: border-box;
      border: 1px solid #DCDFE6;
      border-radius: 3px;
      display: flex;
      align-items: center;
      cursor: pointer;

      .el-tag {
        height: 24px !important;
        line-height: 24px !important;
        margin-right: 4px;
      }
    }
  }

  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after {
    content: '*';
    color: #D44C4C;
    margin-left: 4px;
  }

  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::before {
    content: '*';
    display: none;
  }
}


.el-drawer__header {
  margin-bottom: 0;
  padding: 0;

  .user-edit-header {
    height: 48px;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #edf0f5;

    .icon-guanbi {
      cursor: pointer;
    }
  }
}

.user-edit-footer {
  text-align: right;
  height: 60px;
  line-height: 60px;
}

::v-deep .user-edit-footer,
.user-edit-form {
  .el-button {
    padding: 8px 16px;
  }
}

.role-title {
  color: #999;
  padding: 0px 0 8px;
  font-size: 14px;
}

.AppManager-list {
  width: 99%;
}

.icon-renyuan {
  color: #ffb400;
  font-size: 18px;
  vertical-align: middle;
  padding-right: 4px;
}

.newgroupBody {
  width: 90%;
  padding: 30px 5% 10px;

  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
  }

  .avatar-uploader-icon {
    min-width: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 30px;
  }

  .avatar {
    width: 100px;
    height: 100px;
  }
}

.search-result {
  li {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    cursor: pointer;
  }

  &-title {
    font-weight: 700;
    text-align: center;
    font-size: 16px;
  }

  &-item:hover {
    background: #f7f9fa;
    font-weight: 500;
    color: #38a2fb;
  }
}

.qr-code {
  padding: 16px 8px;

  .row-switch {
    margin-bottom: 8px;
  }

  img {
    margin-top: 8px;
    width: 240px;
    height: 240px;
    border-radius: 17px;
  }
}

.externalUsersNotice {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  margin-bottom: 10px;
  font-family: PingFangSC;
  color: #666666;
  font-size: 14px;
  box-sizing: border-box;
  background-color: white;

  .log {
    margin-left: 10px;
    font-family: PingFangSC;
    color: #4e86ff;
    font-size: 14px;
    cursor: pointer;
  }

  .log:hover {
    color: #65b2ff;
  }

  .log:active {
    color: #2d8dee;
  }
}
</style>
<style>
.el-popover.more-operate {
  padding: 4px 0 4px 0 !important;
}

.el-popover.more-operate p {
  padding: 4px;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
}

.el-popover.more-operate p:hover {
  background-color: #f1f8ff;
}
</style>
